import { useMediaQuery } from "./useMediaQuery";
import { SCREEN_SIZES } from "@/lib/const.ts";

export const useScreenSizes = () => {
  const isSm = useMediaQuery(`(min-width: ${SCREEN_SIZES.sm}px)`);
  const isMd = useMediaQuery(`(min-width: ${SCREEN_SIZES.md}px)`);
  const isLg = useMediaQuery(`(min-width: ${SCREEN_SIZES.lg}px)`);
  const isXl = useMediaQuery(`(min-width: ${SCREEN_SIZES.xl}px)`);
  const is2Xl = useMediaQuery(`(min-width: ${SCREEN_SIZES["2xl"]}px`);

  return { isSm, isMd, isLg, isXl, is2Xl };
};
